import React from 'react';
import { connect } from 'react-redux';
import findResult from '@/utils/resultsHelper';
import { states, updateStates } from '@/constants/lifecycle';
import { showRoleReassign } from '../actions';
import ReassignAction from '../components/ReassignAction';

const ReassignUserAction = ({ user, roleReassign, disabled }) => (
  <ReassignAction roleReassign={roleReassign} users={[user]} disabled={disabled} />
);

const mapStateToProps = ({
  auth: { users },
}, { category, code }) => {
  const user = findResult(users, category, code) || { ...updateStates };
  return ({
    user,
    disabled: user.updateStatus === states.PENDING || user.readStatus === states.PENDING,
  });
};

const mapDispatchToProps = {
  roleReassign: showRoleReassign,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReassignUserAction);
